import React, { useEffect, useState } from "react";
import TelephoneNumbers from "../../TelephoneNumbers";
import { getMisc, updateBillingGroups } from "../../../apiclients/streamsapi_bridge";
import { useNavigate } from "react-router";

function BillingAvailablePHNumbers({ billingID, errors, setError, setSuccessMessage, setIsloading }) {
  const [selectedPHnums, setSelectedPHnums] = useState([]);
  const [aagcode, setaagcode] = useState("");
  const [updatePHNum, setUpdatePHNum] = useState([]);
  const [updateNumbersExecuted, setUpdateNumbersExecuted] = useState(false);
  const [deleteNumberFlag, setDeleteNumberFlag] = useState(false);
  const [dbPhoneNumbers, setdbPhoneNumbers] = useState([]);
  const navigate = useNavigate();
  const [sourceNumber, setsourceNumber] = useState([]);
  const [didFlag, setdidFlag] = useState(false);


  async function fetchBillingPhoneMisc() {
    try {
      let siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
      const params = {
        misc: ["available_phonenumbers"],
        billing_group_id: billingID,
      };

      const serverResponse = await getMisc(siteid, params);
      if (!serverResponse.ok) {
        console.log("Network response was not ok");
        throw new Error("Network response was not ok");
      } else {
        const responseData = await serverResponse.json();
        console.log("Response available Data:", JSON.stringify(responseData));

        setsourceNumber(
          responseData?.misc?.available_phonenumbers ||
          []
        );

      }
    } catch (error) {
      console.error("[fetchAddLocationMisk] Error:", error);
    }
  }

  useEffect(() => {
    if (billingID || didFlag) {
      fetchBillingPhoneMisc();
      setdidFlag(false);
    }
  }, [billingID, didFlag]);


  useEffect(() => {
    if (updatePHNum.length > 0 && updateNumbersExecuted) {
      addPhoneNumbers("added_dids");
      setUpdateNumbersExecuted(false);
    }
  }, [updatePHNum, updateNumbersExecuted]);

  useEffect(() => {
    if (updatePHNum.length > 0 && deleteNumberFlag) {
      addPhoneNumbers("removed_dids");
      setDeleteNumberFlag(false);
    }
  }, [updatePHNum, deleteNumberFlag]);

  async function addPhoneNumbers(fieldName) {
    setIsloading(true);
    let update = {
      reqid: 130,
      siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      bgrp_id: billingID,
      [fieldName]: updatePHNum,
    };

    console.log("Request is :::::::::::::::: " + JSON.stringify(update));

    let saverep = await updateBillingGroups(update);
    console.log(saverep);
    let saverepeMsg = await saverep.json();
    if (saverepeMsg.status && saverepeMsg.status == "success") {
      //debugger;
      if (fieldName === "added_dids") {
        setSelectedPHnums((prev) => [...prev, ...updatePHNum]);
        setdbPhoneNumbers((prev) => [...prev, ...updatePHNum]);
        setSuccessMessage(`Telephone Number ${updatePHNum} added successfully.`);
      } else {
        const updateAddPHNum = selectedPHnums.filter(
          (num) => !updatePHNum.includes(num)
        );
        setSelectedPHnums(updateAddPHNum);
        setdbPhoneNumbers(updateAddPHNum);
        setSuccessMessage(
          `Telephone Number ${updatePHNum} removed successfully.`
        );
      }
      setdidFlag(true);
    } else {
      if (fieldName === "removed_dids") {
        const modifynum = selectedPHnums.filter((num) => !updatePHNum.includes(num));
        setSelectedPHnums([...dbPhoneNumbers]);
      }
      if (saverepeMsg.message?.errors) {
        if (
          saverepeMsg.message?.errors[0].errors &&
          saverepeMsg.message?.errors[0].errors.length > 0
        ) {
          saverepeMsg.message?.errors[0].errors.forEach((err) => {

            setError(err.param_name, {
              type: "server",
              message: err.message,
            });
            const fieldElement = document.querySelector(
              `input[name="${err.param_name}"]`
            );
            if (fieldElement) {
              fieldElement.focus();
            }
          });
        }
      }
    }
    setIsloading(false);
  }
  return (
    <>
      <div className="general-settings" id="general">
        Available Phone Numbers
      </div>

      <TelephoneNumbers
        savedPhoneNumbers={selectedPHnums}
        setSavedPhoneNumbers={setSelectedPHnums}
        setSuccessMessage={setSuccessMessage}
        uniqueid={billingID}
        setUpdatePHNum={setUpdatePHNum}
        setUpdateNumbersExecuted={setUpdateNumbersExecuted}
        sourceNumber={sourceNumber}
        setDeleteNumberFlag={setDeleteNumberFlag}
        dbPhoneNumbers={dbPhoneNumbers}
      />
    </>
  );
}

export default BillingAvailablePHNumbers;
